import { useEffect, useRef } from 'react';
import { useUnsoldLeadDetails } from '../context/UnsoldLeadDetailsContext';

export const useNurturingStrategy = () => {
  const {
    nurturingStrategyStreamingText,
    nurturingStrategyIsStreaming,
    nurturingStrategyConversationId,
    nurturingStrategyLoading,
    nurturingStrategyError,
    initNurturingStrategy,
  } = useUnsoldLeadDetails();

  useEffect(() => {
    // Automatically initialize when conversation_id is available
    if (!nurturingStrategyConversationId && !nurturingStrategyLoading) {
      console.log('🚀 Auto-initializing Nurturing Strategy...');
      initNurturingStrategy();
    }
  }, [nurturingStrategyConversationId, nurturingStrategyLoading, initNurturingStrategy]);

  useEffect(() => {
    console.log('📊 Nurturing Strategy state:', {
      streamingText: nurturingStrategyStreamingText?.substring(0, 50),
      isStreaming: nurturingStrategyIsStreaming,
      conversationId: nurturingStrategyConversationId,
      loading: nurturingStrategyLoading,
    });
  }, [nurturingStrategyStreamingText, nurturingStrategyIsStreaming, nurturingStrategyConversationId, nurturingStrategyLoading]);

  return {
    streamingText: nurturingStrategyStreamingText,
    isStreaming: nurturingStrategyIsStreaming,
    conversationId: nurturingStrategyConversationId,
    loading: nurturingStrategyLoading,
    error: nurturingStrategyError,
  };
};
